/**
 * リクエストのキャンセルとネットワーク失敗を区別するため、
 * AbortController 由来のエラーかどうかを判定する。
 */
export function isAbortError(
  error: unknown
): error is DOMException & { name: "AbortError" } {
  return error instanceof DOMException && error.name === "AbortError";
}
